module.exports = __webpack_public_path__ + "img/车队6.7ca39845.jpg";